// extracted by mini-css-extract-plugin
export default {"wrapper":"BranchPage_wrapper__wil++"};